'use client'
import Section from 'components/Section'
import { useMemoizedContentGetter } from 'utils/contentful'
import { MediaImageStandard, Typography } from 'components/Contentful'

function StandardSectionModule({ title, subTitle, icon, config }) {
  const backgroundConfig = config?.jsonContent?.sectionBackground ?? 'blue100'
  return (
    <Section
      contain={true}
      variant={backgroundConfig}
      className="py-12"
      data-testid="standard-section"
    >
      <div
        className="flex flex-col lg:flex-row items-center justify-between p-4 "
        data-testid="standard-section-wrapper"
      >
        <div className="max-w-[520px]">
          {title && (
            <Typography
              content={title?.textContent}
              variant="headingLg"
              className="text-center lg:text-left  pb-5 "
              data-testid="standard-section-title"
            />
          )}
          {subTitle && (
            <Typography
              content={subTitle?.textContent}
              variant="labelMd"
              mobileVariant="bodySm"
              responsive={true}
              className="text-center lg:text-left  pb-6"
              fontWeight="regular"
              data-testid="standard-section-subtitle"
            />
          )}
        </div>
        <div className="w-full mt-4">
          <div
            className="mt-2 flex items-center justify-center"
            data-testid="standard-section-icon-wrapper"
          >
            <div>
              <MediaImageStandard
                content={icon?.mediaContent}
                layout="fixed"
                className="h-[146px] w-[150px] sm:h-[216px] sm:w-[222px]"
                height={216}
                width={222}
                alt={icon?.title || 'standard image'}
                unoptimized={true}
                fetchPriority="high"
                preload={true}
                quality={100}
              />
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

function StandardSection({ content }) {
  const { title, subTitle, icon, config } = useMemoizedContentGetter(content, [
    'title',
    'subTitle',
    'icon',
    'config',
  ])

  return <StandardSectionModule title={title} subTitle={subTitle} icon={icon} config={config} />
}

export { StandardSection, StandardSectionModule }
export default StandardSection
